export function tryParseInt(str: string | null, defaultValue: number | null): number | null {
    if (str !== null && str.length > 0 && !Number.isNaN(Number(str))) {
        return parseInt(str, 10);
    }
    return defaultValue;
}